import type { ApsOcrExtraction } from '@common/types/apsOcr';
import { resolveAddress } from '@/utils/addressLookup';

/**
 * The scan with its property address replaced by Google's full address, and the city, province
 * and postal code filled where the scan left them empty. Unchanged when Google has no match.
 */
export async function resolveScannedAddress(
    extraction: ApsOcrExtraction,
): Promise<ApsOcrExtraction> {
    const { propertyAddress } = extraction;
    if (!propertyAddress) {
        return extraction;
    }

    const missingParts = [extraction.municipality, extraction.province, extraction.postalCode]
        .filter((part): part is string => Boolean(part))
        .filter((part) => !propertyAddress.toLowerCase().includes(part.toLowerCase()));
    const resolved = await resolveAddress([propertyAddress, ...missingParts].join(', '));
    if (!resolved) {
        return extraction;
    }

    return {
        ...extraction,
        propertyAddress: resolved.address,
        municipality: extraction.municipality ?? resolved.city,
        province: extraction.province ?? resolved.province,
        postalCode: extraction.postalCode ?? resolved.postalCode,
    };
}
